import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Checkbox } from '@material-ui/core';
import _ from 'lodash';
import classNames from 'classnames';

import '../SportsFilters.scss';
import { getFlag } from '../../../../utils/utils';
import Icon from '../../../Icon/Icon';

class TreeItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isChecked: false,
      checkedChildren: 0,
      checkedGrandChildren: 0
    };
  }

  componentDidMount() {
    const {
      item: { code, categories, tournaments, meetingInfos },
      level,
      children,
      location,
      filterSports,
      changeFilterSportsMeeting
    } = this.props;
    const query = new URLSearchParams(location.search);
    let meetings = [];

    if (query.has('meetings')) {
      meetings = query.get('meetings').split(',');
      changeFilterSportsMeeting(meetings);
    }

    const hasTournamentSelected = filterSports.tournaments.includes(code?.toString());
    const hasMeetingSelected = meetings.includes(meetingInfos?.meetingCode.toString());

    if (level === -1) {
      this.setState({ isOpen: true });
    }

    if (level === 2 && (hasTournamentSelected && meetingInfos === undefined|| hasMeetingSelected)) {
      this.setState({ isChecked: true });
    }

    if (level === 1) {
      const tournamentCodes = _.reduce(tournaments, (prev, curr) => {
        return [...prev, curr.code.toString()];
      }, []);
      const checkedChildren = _.intersection(tournamentCodes, filterSports.tournaments).length;

      if (checkedChildren === children.length) {
        this.setState({ isChecked: true, checkedChildren });
      } else {
        this.setState({ isChecked: false, checkedChildren });
      }
    }

    if (level === 0) {
      let checkedGrandChildren = 0;
      const checkedChildren = _.reduce(categories, (prev, curr) => {
        const tournamentCodes = _.reduce(curr.tournaments, (prevT, currT) => {
          return [...prevT, currT.code.toString()];
        }, []);
        const checkedTournaments = _.intersection(tournamentCodes, filterSports.tournaments).length;
        checkedGrandChildren += checkedTournaments;

        return prev += (checkedTournaments === tournamentCodes.length ? 1 : 0);
      }, 0);

      if (checkedChildren === children.length) {
        this.setState({ isChecked: true, checkedChildren, checkedGrandChildren: 0 });
      } else {
        this.setState({ isChecked: false, checkedChildren, checkedGrandChildren });
      }
    }

    if (level === -1){
      this.setState({ isOpen: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      item: { code, categories, tournaments, meetingInfos },
      level,
      children,
      filterSports
    } = this.props;

    if (prevProps.filterSports.tournaments !== filterSports.tournaments) {
      if (level === 2) {
        const hasTournamentSelected = filterSports.tournaments.includes(code.toString());
        const hasMeetingSelected = filterSports.meetings.includes(meetingInfos?.meetingCode.toString());

        if (hasTournamentSelected && !this.state.isChecked && meetingInfos === undefined) {
          this.setState({ isChecked: true });
        } else if (!hasTournamentSelected && this.state.isChecked && meetingInfos === undefined) {
          this.setState({ isChecked: false });
        } else if (hasMeetingSelected && !this.state.isChecked
           && meetingInfos !== undefined) {
          this.setState({ isChecked: true });
        } else if (!hasMeetingSelected && this.state.isChecked
          && meetingInfos !== undefined) {
          this.setState({ isChecked: false });
        }
      }

      if (level === 1) {
        const tournamentCodes = _.reduce(tournaments, (prev, curr) => {
          return [...prev, curr.code.toString()];
        }, []);
        const checkedChildren = _.intersection(tournamentCodes, filterSports.tournaments).length;

        if (checkedChildren === children.length) {
          this.setState({ isChecked: true, checkedChildren });
        } else if (prevState.checkedChildren !== checkedChildren) {
          this.setState({ isChecked: false, checkedChildren });
        }
      }

      if (level === 0) {
        let checkedGrandChildren = 0;
        const checkedChildren = _.reduce(categories, (prev, curr) => {
          const tournamentCodes = _.reduce(curr.tournaments, (prevT, currT) => {
            return [...prevT, currT.code.toString()];
          }, []);
          const checkedTournaments = _.intersection(tournamentCodes, filterSports.tournaments).length;
          checkedGrandChildren += checkedTournaments;

          return prev += (checkedTournaments === tournamentCodes.length ? 1 : 0);
        }, 0);

        if (checkedChildren === children.length) {
          this.setState({ isChecked: true, checkedChildren, checkedGrandChildren: 0 });
        } else {
          this.setState({ isChecked: false, checkedChildren, checkedGrandChildren });
        }
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    const {
      level,
      filterSports,
      item: { code, categories, tournaments/* , meetingInfos */ }
    } = this.props;

    if (filterSports.tournaments !== nextProps.filterSports.tournaments) {
      if (level === 2) {
        const currIndex = filterSports.tournaments.indexOf(code.toString());
        const nextIndex = nextProps.filterSports.tournaments.indexOf(code.toString());

        return currIndex !== nextIndex;
      }

      if (level === 1) {
        const tournamentCodes = _.reduce(tournaments, (prev, curr) => {
          return [...prev, curr.code.toString()];
        }, []);
        const nextTournamentCodes = _.reduce(nextProps.item.tournaments, (prev, curr) => {
          return [...prev, curr.code.toString()];
        }, []);
        const currCheckedChildren = _.intersection(tournamentCodes, filterSports.tournaments).length;
        const nextCheckedChildren = _.intersection(nextTournamentCodes, nextProps.filterSports.tournaments).length;

        return currCheckedChildren !== nextCheckedChildren;
      }

      if (level === 0) {
        const currCheckedChildren = _.reduce(categories, (prev, curr) => {
          const tournamentCodes = _.reduce(curr.tournaments, (prevT, currT) => {
            return [...prevT, currT.code.toString()];
          }, []);
          const checkedTournaments = _.intersection(tournamentCodes, filterSports.tournaments).length;

          return prev += checkedTournaments;
        }, 0);
        const nextCheckedChildren = _.reduce(nextProps.item.categories, (prev, curr) => {
          const tournamentCodes = _.reduce(curr.tournaments, (prevT, currT) => {
            return [...prevT, currT.code.toString()];
          }, []);
          const checkedTournaments = _.intersection(tournamentCodes, nextProps.filterSports.tournaments).length;

          return prev += checkedTournaments;
        }, 0);

        return currCheckedChildren !== nextCheckedChildren;
      }
    }

    return true;
  }

  toggleOpen = (e) => {
    if (e.target.type !== 'checkbox') {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }

  changeFilters = (tournamentCode, meetingCode) => () => {
    this.setState({ isChecked: !this.state.isChecked }, async () => {
      const {
        level,
        sport,
        category,
        changeFilterSportsTournaments,
        changeFilterSportsMeeting,
        item,
        filterSports,
        history,
        location
      } = this.props;
      const query = new URLSearchParams(location.search);
      const hasTournamentSelected = filterSports.tournaments.includes(item.code.toString());
      const hasMeetingSelected = filterSports.meetings.includes(item.meetingInfos?.meetingCode.toString());
      let tournaments = [...filterSports.tournaments];

      const meetings = meetingCode ? await changeFilterSportsMeeting(meetingCode.toString()): [];
      if (hasTournamentSelected || !hasMeetingSelected) {
        tournaments = await changeFilterSportsTournaments({
          level,
          code: tournamentCode.toString(),
          sport: sport && sport.toString(),
          category: category && category.toString(),
          checked: this.state.isChecked
        });
      }

      window.scrollTo(0, 300);

      history.replace({
        pathname: location.pathname,
        search: `?range=${ query.get('range') || '' }&tournaments=${ tournaments }&meetings=${ meetings }`
      });
    });
  }

  selectTop = (filter) => () => {
    const { getEventsByTop, location, history } = this.props;

    getEventsByTop(filter);
    const query = new URLSearchParams(location.search);

    window.scrollTo(0, 300);

    history.replace({
      pathname: location.pathname,
      search: `?range=${ query.get('range') || '' }&tournaments=`
    });
  }

  renderSport() {
    const { isChecked, isOpen, checkedChildren, checkedGrandChildren } = this.state;
    const { item, children } = this.props;

    return (
      <li className={
        classNames({
          'tree__item': true,
          'tree__item--closed': !isOpen
        })
      }
      >
        <div className="tree__item-container" onClick={ this.toggleOpen }>
          <div className="tree__country sport-icon">{ item.sportIcon }</div>
          <span className="tree__name">{ item.name }</span>
          <div className="tree__actions">
            <span className="tree__total">{ item.eventsCount }</span>
            <Checkbox
              checked={ isChecked }
              indeterminate={ !isChecked && (checkedChildren > 0 && checkedChildren < children.length || checkedGrandChildren > 0) }
              className="tree__checkbox tree__checkbox--sport"
              name="selected"
              color="default"
              onChange={ this.changeFilters(item.code) }
            />
            <Icon className="tree__arrow" icon="arrow" />
          </div>
        </div>
        <ul className="tree__node-list">
          { children }
        </ul>
      </li>
    );
  }

  renderCategory() {
    const { isChecked, isOpen, checkedChildren } = this.state;
    const { item, children } = this.props;

    return (
      <li className={
        classNames({
          'tree__node-item': true,
          'tree__node-item--closed': !isOpen
        })
      }
      >
        <div className="tree__item-container" onClick={ this.toggleOpen }>
          <div className="tree__country" style={ { backgroundImage: `url(${ getFlag(item.countryCode) })` } } ></div>
          <span className="tree__name">{ item.name }</span>
          <div className="tree__actions">
            <span className="tree__total">{ item.eventsCount }</span>
            <Checkbox
              checked={ isChecked }
              indeterminate={ !isChecked && checkedChildren > 0 && checkedChildren < children.length }
              className="tree__checkbox tree__checkbox--category"
              name="selected"
              color="default"
              onChange={ this.changeFilters(item.code) }
            />
            <Icon className="tree__arrow" icon="arrow" />
          </div>
        </div>
        <ul className="tree__list">
          { children }
        </ul>
      </li>
    );
  }

  renderTournament() {
    const { isChecked } = this.state;
    const { item, filterSports } = this.props;
    const hasMeeting = !_.isEmpty(item.meetingInfos);
    const name = hasMeeting ? item.meetingInfos.name : item.name;

    return (
      <li className="tree__item">
        <div
          className="tree__item-container tree__item-container--no-radius"
          onClick={ this.changeFilters(item.code, hasMeeting && item.meetingInfos.meetingCode) }
        >
          <span className="tree__name">{ name }</span>
          <div className="tree__actions">
            <span className="tree__total">{ item.eventsCount }</span>
            <Checkbox
              checked={ isChecked && filterSports.meetings.includes(item.meetingId) }
              className="tree__checkbox tree__checkbox--tournament"
              name="selected"
              color="secondary"
            />
            <div className="tree__arrow"></div>
          </div>
        </div>
      </li>
    );
  }

  renderTopHeader() {
    const { item, children } = this.props;

    return (
      <li className={
        classNames({
          'tree__item': true,
          'tree__item--quick-links': true,
          'tree__item--closed': this.state.isOpen
        })
      }
      >
        <div className="tree__item-container" onClick={ this.toggleOpen }>
          <span className="tree__title">{ item.name }</span>
          <div className="tree__actions">
            <Icon className="tree__arrow" icon="arrow" />
          </div>
        </div>
        <ul className="tree__node-list">
          { children }
        </ul>
      </li>
    );
  }

  renderTop() {
    const { item, selectedTop } = this.props;

    return (
      <li className="tree__node-item">
        <div
          className={
            classNames({
              'tree__item-container': true,
              'tree__item-container--active': selectedTop === item.topFilter
            })
          }
          onClick={ this.selectTop(item.topFilter) }
        >
          <div className="tree__country sport-icon">{ item.icon }</div>
          <span className="tree__name">{ item.name }</span>
          <div className="tree__actions">
            <span className="tree__total">{ item.events }</span>
          </div>
        </div>
      </li>
    );
  }

  render() {
    switch (this.props.level) {
      case 0:
        return this.renderSport();

      case 1:
        return this.renderCategory();

      case 2:
        return this.renderTournament();

      case -1:
        return this.renderTopHeader();

      default:
        return this.renderTop();
    }
  }

}

TreeItem.propTypes = {
  t: PropTypes.func,
  children: PropTypes.array,
  item: PropTypes.object,
  meeting: PropTypes.number,
  level: PropTypes.number,
  changeFilterSportsTournaments: PropTypes.func,
  changeFilterSportsMeeting: PropTypes.func,
  sport: PropTypes.number,
  category: PropTypes.number,
  filterSports: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  getEventsByTop: PropTypes.func,
  selectedTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const mapState = state => ({
  filterSports: state.events.filterSports,
  selectedTop: state.events.filterSports.top
});

const mapDispatch = dispatch => ({
  changeFilterSportsTournaments: (obj) => dispatch.events.changeFilterSportsTournaments(obj),
  changeFilterSportsMeeting: (obj) => dispatch.events.changeFilterSportsMeeting(obj),
  getEventsByTop: (value) => dispatch.events.getEventsByTop(value)
});

export default withRouter(connect(mapState, mapDispatch)(TreeItem));
